module.exports = __webpack_public_path__ + "media/images/my_tasks_banner-abe9ea4a.svg";